import { render } from "./ArtistValueIndicator.vue?vue&type=template&id=308ff155&scoped=true"
import script from "./ArtistValueIndicator.vue?vue&type=script&lang=js"
export * from "./ArtistValueIndicator.vue?vue&type=script&lang=js"

import "./ArtistValueIndicator.vue?vue&type=style&index=0&id=308ff155&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308ff155"]])

export default __exports__